var _excluded = ["contentClassName", "overlayClassName", "trigger", "children", "contentStyle", "overlayStyle", "transitionProps", "disableAnimation"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import Modal2 from "./modal-2";
import useOpenClose from "../../hooks/use-open-close";

var ModalTrigger2 = function ModalTrigger2(_ref) {
  var contentClassName = _ref.contentClassName,
      overlayClassName = _ref.overlayClassName,
      trigger = _ref.trigger,
      children = _ref.children,
      contentStyle = _ref.contentStyle,
      overlayStyle = _ref.overlayStyle,
      transitionProps = _ref.transitionProps,
      disableAnimation = _ref.disableAnimation,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useOpenClose = useOpenClose(false),
      _useOpenClose2 = _slicedToArray(_useOpenClose, 3),
      is_open = _useOpenClose2[0],
      open = _useOpenClose2[1],
      close = _useOpenClose2[2];

  return /*#__PURE__*/React.createElement(React.Fragment, null, trigger({
    is_open: is_open,
    close: close,
    open: open
  }), /*#__PURE__*/React.createElement(Modal2, _extends({
    onClose: close,
    isOpen: is_open,
    contentClassName: contentClassName,
    overlayClassName: overlayClassName,
    overlayStyle: overlayStyle,
    contentStyle: contentStyle,
    transitionProps: transitionProps,
    disableAnimation: disableAnimation
  }, rest), typeof children === "function" ? children({
    close: close
  }) : children));
};

ModalTrigger2.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  contentClassName: PropTypes.string,
  overlayClassName: PropTypes.string,
  trigger: PropTypes.func.isRequired,
  contentStyle: PropTypes.object,
  overlayStyle: PropTypes.object,
  transitionProps: PropTypes.object,
  disableAnimation: PropTypes.bool
};
export default ModalTrigger2;